import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  pushEvent(data: DataLayerEvent | Record<string, unknown>) {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(data);
  }
}
